import { api } from '@/modules/apiv2';

export default {
  state: {
    dispatchableEvents: [],
    dispatches: [],
  },

  getters: {
    dispatchableEvents(state) {
      return state.dispatchableEvents;
    },

    dispatches(state) {
      return state.dispatches;
    },
  },

  mutations: {
    setDispatchableEvents(state, dispatchableEvents) {
      state.dispatchableEvents = dispatchableEvents;
    },

    setDispatches(state, dispatches) {
      state.dispatches = dispatches;
    },
  },

  actions: {
    getDispatchableEvents({ commit, getters }, startTime) {
      const endpoint = getters.eventsEndpoint;
      let getUrl = `${endpoint}/dispatchable`;

      if (startTime) {
        getUrl += `?startTime=${startTime}`;
      }

      return api
        .get(getUrl)
        .then((data) => {
          commit('setDispatchableEvents', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    getDispatches({ commit, getters }, allDispatches = false) {
      const endpoint = getters.dispatchesEndpoint;
      const fullUrl = `${endpoint}${allDispatches ? '?complete=1' : ''}`;

      return api
        .get(fullUrl)
        .then((data) => {
          commit('setDispatches', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    updateDispatch({ getters }, data) {
      const endpoint = getters.dispatchesEndpoint;

      var input = new Object();
      input.UpdatedSubscribers = data.UpdatedSubscribers;
      input.TimeToLive = data.TimeToLive;

      return api
        .put(`${endpoint}/${data.id}`, input)
        .then((data) => {
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    createDispatch({ getters }, dispatchInput) {
      const endpoint = getters.dispatchesEndpoint;

      return api
        .post(endpoint, dispatchInput)
        .then((data) => {
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
